import axios from 'axios'
import { API_ENDPOINT } from '../../tools/apiEndpoint'

export const importForkliftApi = async ({ exec, file, email }) => {
  const formData = new FormData()
  formData.append('file', file)
  const URL = `${API_ENDPOINT}/forklift/import`
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: { exec }
  }

  const response = await axios.post(
    URL,
    null || formData,
    config
  )

  return response
}
